import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00e4bdce"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = ["data-kt-indicator", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Sign Up", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Signing up... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "validation-schema": _ctx.formSchema,
    ref: "registrationForm"
  }, {
    default: _withCtx(({ handleSubmit, validate, values }) => [
      _createElementVNode("form", {
        class: "form w-100",
        novalidate: "true",
        id: "kt_sign_in_form",
        onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.submitRegistrationForm)), ["prevent"])
      }, [
        _createVNode(_component_FormField, {
          required: true,
          value: values.email,
          containerClass: "fv-row contain-content",
          formControlClass: "form-control form-control-lg text-login",
          label: "Email",
          showLabel: false,
          name: "email",
          placeholder: "Email",
          type: "email"
        }, null, 8, ["value"]),
        _createVNode(_component_FormField, {
          required: true,
          value: values.password,
          containerClass: "fv-row contain-content",
          formControlClass: "form-control form-control-lg text-login",
          showLabel: false,
          name: "password",
          placeholder: "Password",
          type: "password"
        }, null, 8, ["value"]),
        _createVNode(_component_FormField, {
          required: true,
          value: values.password_confirmation,
          containerClass: "fv-row contain-content",
          formControlClass: "form-control form-control-lg text-login",
          showLabel: false,
          name: "password_confirmation",
          placeholder: "Confirm Password",
          type: "password"
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-lg w-100 mb-5 btn-sign-in",
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            onClick: validate
          }, _hoisted_6, 8, _hoisted_3),
          (_ctx.recaptcha_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " ReCaptcha is having an error. Please refresh page and try again. "))
            : _createCommentVNode("", true)
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}